export enum Ledger {
  GET_PREFUND_LEDGER_REQUEST = '@ledger/GET_PREFUND_LEDGER_REQUEST',
  GET_PREFUND_LEDGER_SUCCESS = '@ledger/GET_PREFUND_LEDGER_SUCCESS',
  GET_PREFUND_LEDGER_FAIL = '@ledger/GET_PREFUND_LEDGER_FAIL',

  GET_ACCEPTANCE_LEDGER_REQUEST = '@ledger/GET_ACCEPTANCE_LEDGER_REQUEST',
  GET_ACCEPTANCE_LEDGER_SUCCESS = '@ledger/GET_ACCEPTANCE_LEDGER_SUCCESS',
  GET_ACCEPTANCE_LEDGER_FAIL = '@ledger/GET_ACCEPTANCE_LEDGER_FAIL',
}
